import React from 'react';
import { BsArrowRight } from 'react-icons/bs';
import { Link } from 'react-router-dom';

function ServicesOneCard({ bgImg, icon, heading, btnText, slug }) {
    return (
        <div className="col-12 col-md-4 col-xl-3 mb-4" style={{ height: "348px" }}>
            <div className="single-service-item service-1 h-100 d-flex flex-column">
                <div
                    className="service-bg bg-cover"
                    style={{
                        backgroundImage: `url('${bgImg}')`,
                    }}
                />
                <div className="icon d-flex justify-content-center align-items-center">
                    <img src={icon} alt="icon" style={{ width: "70px"}} />
                </div>
                <h4>{heading}</h4>
                {/* <Link to={`/services/${slug}`}>
                    <span>{btnText}</span>
                    <BsArrowRight style={{ fontSize: '18px' }} />
                </Link> */}
            </div>
        </div>
    );
}

export default ServicesOneCard;
